
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const LaunchpadCTA = () => {
  return (
    <section className="py-24 lg:py-32 bg-charcoal relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-charcoal to-charcoal/90"></div>
      
      <div className="relative max-w-5xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="rounded-2xl overflow-hidden h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/5d61350de2a54050b9dc1d8a72149c33.jpg"
                alt="PM Launchpad mentorship"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="font-inter text-xs uppercase tracking-widest text-warm-gold mb-4">
              Ready to Launch?
            </p>
            
            <h2 className="font-playfair text-4xl lg:text-5xl font-semibold text-warm-white leading-tight mb-6">
              Your PM Career <br />
              Starts <em className="text-warm-gold">Here</em>
            </h2>
            
            <p className="font-inter text-lg text-warm-white/70 mb-8 leading-relaxed">
              Join PM Launchpad and gain the mentorship, frameworks, and confidence you need to excel as a project manager. Limited spots available for our next cohort.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/apply"
                className="inline-flex items-center justify-center bg-warm-gold text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-soft-bronze transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Apply for Next Cohort
              </Link>
              <Link
                to="/book-consultation"
                className="inline-flex items-center justify-center border-2 border-warm-white text-warm-white font-inter font-semibold px-8 py-4 rounded-full hover:bg-warm-white hover:text-charcoal transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Schedule Discovery Call
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default LaunchpadCTA;
